import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../../ui/Button';

/**
 * Coquille commune des fenetres d'edition du catalogue : voile, panneau, en-tete, corps defilant et
 * boutons colles en bas.
 *
 * Fiche plat et fiche formule s'ouvrent en fenetre modale et non sous la liste : auparavant le formulaire
 * tombait hors ecran des qu'il y avait quelques elements, et le clic semblait n'avoir aucun effet
 * (demandes d'Emeni, 2026-08-23 puis 2026-08-25). Les boutons restent colles en bas pour ne jamais etre
 * hors de portee sur un formulaire long.
 */
export function CatalogModalShell({ titre, largeur = 'sm:max-w-lg', onClose, onSave, saving, children }: {
    titre: string;
    /** Le formulaire de formule est plus large que celui d'un plat : il aligne des categories entieres. */
    largeur?: string;
    onClose: () => void;
    onSave: () => void;
    saving: boolean;
    children: React.ReactNode;
}) {
    return (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 p-0 sm:p-4" onClick={onClose}>
            <div className={`bg-surface border border-border w-full ${largeur} sm:rounded-2xl rounded-t-2xl max-h-[92vh] sm:max-h-[88vh] flex flex-col shadow-2xl`} onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between gap-2 px-4 py-3 border-b border-border shrink-0">
                    <h3 className="text-sm font-bold text-content">{titre}</h3>
                    <button type="button" onClick={onClose} className="p-1 rounded-lg hover:bg-surface-soft text-content-muted hover:text-content"><X size={16} /></button>
                </div>
                <div className="overflow-y-auto px-4 py-3.5 flex-1">{children}</div>
                <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-border shrink-0">
                    <Button variant="secondary" size="sm" onClick={onClose}>Annuler</Button>
                    <Button size="sm" onClick={onSave} disabled={saving}>{saving ? 'Enregistrement...' : 'Enregistrer'}</Button>
                </div>
            </div>
        </div>
    );
}
